module.exports = {
  BoxShadow: {
    DividerBottom: { x: "0", y: "1", blur: "0", spread: "0", color: "#F1F1F2" },
    DividerTop: { x: "0", y: "-1", blur: "0", spread: "0", color: "#F1F1F2" },
    ButtonFocusDefault: {
      x: "0",
      y: "0",
      blur: "0",
      spread: "3",
      color: "#E2E2E3",
    },
    ButtonFocusPrimary: {
      x: "0",
      y: "0",
      blur: "0",
      spread: "3",
      color: "#D3D5FF",
    },
    ButtonFocusDanger: {
      x: "0",
      y: "0",
      blur: "0",
      spread: "3",
      color: "#FBCFCA",
    },
    ButtonHover: [
      {
        x: "0",
        y: "0",
        blur: "0",
        spread: "3",
        color: "rgba(color.Primary.Black, 0)",
        type: "dropShadow",
      },
      {
        x: "0",
        y: "10",
        blur: "14",
        spread: "0",
        color: "rgba(color.Primary.Black, 0.08)",
        type: "dropShadow",
      },
      {
        x: "0",
        y: "6",
        blur: "6",
        spread: "0",
        color: "rgba(color.Primary.Black, 0.06)",
        type: "dropShadow",
      },
    ],
    TooltipHover: [
      {
        x: "0",
        y: "10",
        blur: "14",
        spread: "0",
        color: "rgba(color.Primary.Black, 0.08)",
        type: "dropShadow",
      },
      {
        x: "0",
        y: "0",
        blur: "14",
        spread: "0",
        color: "rgba(color.Primary.Black, 0.12)",
        type: "dropShadow",
      },
    ],
    Elevation100: [
      {
        x: "0px",
        y: "4px",
        blur: "5px",
        spread: "0px",
        color: "rgba(191, 191, 199, 0.2)",
      },
      {
        x: "0px",
        y: "3px",
        blur: "14px",
        spread: "0px",
        color: "rgba(191, 191, 199, 0.12)",
      },
      {
        x: "0px",
        y: "8px",
        blur: "10px",
        spread: "0px",
        color: "rgba(191, 191, 199, 0.14)",
      },
    ],
    Elevation200: [
      {
        x: "0px",
        y: "10px",
        blur: "14px",
        spread: "0px",
        color: "rgba(0, 0, 0, 0.08)",
      },
      {
        x: "0px",
        y: "6px",
        blur: "6px",
        spread: "0px",
        color: "rgba(0, 0, 0, 0.06)",
      },
    ],
    Elevation300: [
      {
        x: "0px",
        y: "11px",
        blur: "15px",
        spread: "0px",
        color: "rgba(191, 191, 199, 0.2)",
      },
      {
        x: "0px",
        y: "9px",
        blur: "46px",
        spread: "0px",
        color: "rgba(191, 191, 199, 0.12)",
      },
      {
        x: "0px",
        y: "24px",
        blur: "38px",
        spread: "0px",
        color: "rgba(191, 191, 199, 0.14)",
      },
    ],
    HairlineBottom: {
      x: "0",
      y: "1",
      blur: "0",
      spread: "0",
      color: "#F1F1F2",
    },
    HairlineTop: { x: "0", y: "-1", blur: "0", spread: "0", color: "#F1F1F2" },
    HairlineRight: { x: "1", y: "0", blur: "0", spread: "0", color: "#F1F1F2" },
  },
};
